export default {
	sidebarHeader: 'Stavy kontaktů v kampani',
	tableHeader: 'Výběr stavů pro kampaň',
	dropText: 'Vyber stav z lišty',
	usedStateWarning: 'Nelze odstranit stav, na který je již vykázáno',
};
